'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileContents = renderWithRef('StandardTileContents', null, (e, n)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: [
            'swan-standard-tile-contents'
        ],
        props: e,
        children: e.children
    }));

export { StandardTileContents };
